// possible options:
// microsoft
// google
// saml
// password

const enabledAuthMethods = (import.meta.env.VITE_APP_AUTH_METHODS || 'microsoft,google,password')
  .split(',')
  .map((method) => method.trim().toLowerCase());

const isMicrosoftEnabled = enabledAuthMethods.includes('microsoft');
const isGoogleEnabled = enabledAuthMethods.includes('google');
const isSamlEnabled = enabledAuthMethods.includes('saml');
const isPasswordEnabled = enabledAuthMethods.includes('password');

export { isMicrosoftEnabled, isGoogleEnabled, isSamlEnabled, isPasswordEnabled };
